import Repository from '../repository';

const resource = '/billing-address';

export default {
  store(address) {
    return Repository.post(`${resource}`, address);
  },
  show(addressId) {
    return Repository.get(`${resource}/${addressId}`);
  },
  update(address) {
    return Repository.patch(`${resource}/${address.id}`, address);
  },
  delete(address) {
    return Repository.delete(`${resource}/${address.id}`);
  },
};
